import TriggerSerializer from 'eflex/serializers/trigger';

export default class PlcHardwareTriggerSerializer extends TriggerSerializer {}
